export default "__VITE_ASSET__230839ff__"